export enum SkeletonDrawerTemplate {
  Short = 1,
  Full = 5
}
